import {DELETE_GROWTH_PATH_START} from "../../types";

export const delete_growth_path = (payload) => ({
    type: DELETE_GROWTH_PATH_START,
    payload,
});
